import { render, staticRenderFns } from "./RequestDemoText.vue?vue&type=template&id=6161bd4e&scoped=true&"
import script from "./RequestDemoText.vue?vue&type=script&lang=ts&"
export * from "./RequestDemoText.vue?vue&type=script&lang=ts&"
import style0 from "./RequestDemoText.vue?vue&type=style&index=0&id=6161bd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6161bd4e",
  null
  
)

export default component.exports